module.exports = __webpack_public_path__ + "img/gear-ico.617e1030.svg";